<template>
	<o-card
		class="card-stat"
		gradient="warning">
		<div
			v-if="setup.numberToProceed"
			class="stat">
			<div class="stat__value">{{ setup.numberToProceed }}</div>
			<div class="stat__legend">{{ setup.label }}</div>
			<o-icon
				class="stat__icon"
				font-icon="icon-interface-time-book-2"/>
		</div>
		<h3
			v-else
			class="card-stat__title">
			Aucun relevé d'heures à saisir cette semaine
		</h3>

		<template
			v-if="setup.numberToProceed"
			#actions>
			<o-button
				outline
				color="default"
				@click="setup.goToTimeTicket()">
				<!-- Simulation du pluriel si pas de nouveaux -->
				Voir {{ `le relevé`.pluralize(setup.numberToProceed || 2, false) }} d'heures
			</o-button>
		</template>

		<o-loader
			color="warning"
			:visible="!setup.dataLoaded"/>
	</o-card>
</template>

<script setup lang="ts">
import DashboardTimeTicketToFillCardSetupService from '@/setup/dashboard/DashboardTimeTicketToFillCardSetupService';
const setup = new DashboardTimeTicketToFillCardSetupService();
</script>


<style scoped lang="less">
.card-stat {
  height: 100%;
  overflow: hidden;

  .orion-card__body {
    display: flex;
    justify-content: center;
  }

  .stat {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__value {
      padding: 0.6rem;
      font-size: 5.6rem;
      line-height: 1;
      font-weight: bold;
      text-shadow: 0 2px 3px fade(black, 20);
    }

    &__legend {
      flex: 1 0 0%;
      margin-top: 0.1rem;
      padding: 0.1rem;
      font-size: 1rem;
      line-height: 1.3rem;
      font-weight: bold;
      text-transform: uppercase;
      text-align: center;
    }

    &__icon {
      position: absolute;
      top: 15px;
      right: 15px;
      opacity: 0.3;
      font-size: 7.5rem;
    }
  }

  &__title {
    color: white;
    margin: 0.6rem 0 0.9rem;
    padding: 0.3rem;
  }
}
</style>
